export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1766113483154-727ed6432fd1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  cocktail: "https://images.unsplash.com/photo-1739203852867-87038459791a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  beer: "https://images.unsplash.com/photo-1615332579037-3c44b3660b53?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  weddingToast: "https://images.unsplash.com/photo-1758810410268-5e9d85b60065?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  celebration: "https://images.unsplash.com/photo-1761499101934-4c79d09b14e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  friends: "https://images.unsplash.com/photo-1758272133395-b0f83eb6f554?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  weddingReception: "https://images.unsplash.com/photo-1766113483422-7c871de23591?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  outdoorParty: "https://images.unsplash.com/photo-1766113483154-727ed6432fd1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  beerPour: "https://images.unsplash.com/photo-1766589220777-a4ba921faab6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  barspotLogo: "https://lirp.cdn-website.com/21979d5c/dms3rep/multi/opt/logo+text2-1920w.jpg",
  barspotLogoRound: "https://customer-assets.emergentagent.com/job_e827ccd5-2f27-4774-b667-e51a7471a3ba/artifacts/fdqtel6m_bARSPOT.jpg"
};
